'use client'

import SiteMapSaytExtended from './SiteMapSaytExtended'
import SiteMapTitle from './SitemapTitle'

import LandingPageLinkRack from 'Clutch/Organisms/LandingPageLinkRack'

const SimpleSitemap = ({ title, links, childProps, heroImageUrl }) => {
  return (
    <SiteMapTitle title={title} heroImageUrl={heroImageUrl}>
      <SiteMapSaytExtended
        links={links}
        facetName={title}
        childProps={childProps}
        quickSearchButtons={links.filter((x) => x.isFeatured).map((x) => x.displayValue)}
        ChildComponent={LandingPageLinkRack}
      />
    </SiteMapTitle>
  )
}

export default SimpleSitemap
